module.exports = __webpack_public_path__ + "static/media/azure.e34a90d5.svg";